var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "already-allocated-con" },
    [
      _c("vue-good-table", {
        attrs: { columns: _vm.columns, rows: _vm.rows },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "btn"
                  ? _c("span", [
                      props.row.btn
                        ? _c(
                            "button",
                            {
                              staticClass: "order-btn",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return (function() {
                                    return _vm.onClick(props.row.id)
                                  })($event)
                                }
                              }
                            },
                            [_vm._v("Allocated Order")]
                          )
                        : _vm._e()
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n    " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n  "
                      )
                    ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }